import { FC, useEffect } from 'react';
import { isEmpty } from 'radash';
import { newCollectionStore } from '@modules/collections/adapter/outbound/stores/newCollection.store';
import { NewCollectionLayout } from '@components/collection/newCollection';
import { NewCollectionWrapper } from '@components/collection/newCollection/NewCollectionLayout.style';
import { Content } from '@components/layouts';
import SkeletonNewCollection from '@components/skeleton/newCollection/NewCollection';
const NewCollectionProvider: FC = () => {
  const {
    newCollectionList,
    setNewCollection
  } = newCollectionStore(state => state);
  useEffect(() => {
    if (isEmpty(newCollectionList)) setNewCollection();
  }, []);
  return <Content>
            {isEmpty(newCollectionList) ? <SkeletonNewCollection /> : newCollectionList.map(newCollection => <NewCollectionWrapper key={newCollection.id}>
                        <NewCollectionLayout data={newCollection} />
                    </NewCollectionWrapper>)}
        </Content>;
};
export default NewCollectionProvider;